import PropTypes from "prop-types";

// Components
import Button from "./Button";

// Utils
import { emptyFunction } from "../../utils/miscUtils";

const ButtonContainer = (props) => {
    return <Button {...props} />;
};

ButtonContainer.defaultProps = { onClick: emptyFunction };

ButtonContainer.propTypes = { onClick: PropTypes.func, text: PropTypes.string };

export default ButtonContainer;
